import { useState, useEffect } from "react";
import ValentineBg from "../Components/ValentineBg/ValentineBg";
import "bootstrap/dist/css/bootstrap.min.css";
import KP from "../Images/svg/KP-LB.svg";
import IBM from "../Images/IBMpartner.png";
import { useDispatch } from 'react-redux';
import { setTheme } from '../Redux/themeSlice';
import { useTranslation } from 'react-i18next';
import { setFormData } from '../Redux/formSlice';
import { Link } from 'react-router-dom';
import { setLanguage } from "../Redux/languageSlice";

function NewHome() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [selected, setSelected] = useState(t('recipient_crush'));
  const [selectedTheme, setSelectedTheme] = useState("red-theme");
  const [step, setStep] = useState(0);

  const recipients = [
    { label: t('recipient_partner'), emoji: "💍" },
    { label: t('recipient_crush'), emoji: "🥰" },
    { label: t('recipient_best_friend'), emoji: "😎" },
    { label: t('recipient_special_friend'), emoji: "👯" },
    { label: t('recipient_mother'), emoji: "👩‍🍼" },
    { label: t('recipient_father'), emoji: "👨‍🍼" },
    { label: t('recipient_sibling'), emoji: "👫" },
    { label: t('recipient_child'), emoji: "👶" },
    { label: t('recipient_grandparent'), emoji: "👵" },
    { label: t('recipient_other'), emoji: "🎁" },
  ];

  const themes = [
    { id: 'red-theme', icon: 'fa-solid fa-heart', label: t('theme_amour'), desc: t('theme_amour_desc') },
    { id: 'classic-theme', icon: 'fa-solid fa-gem', label: t('theme_classic'), desc: t('theme_classic_desc') },
    { id: 'pink-theme', icon: 'fa-solid fa-wand-magic-sparkles', label: t('theme_sweetheart'), desc: t('theme_sweetheart_desc') },
  ];

  const handleThemeChange = (theme) => {
    document.body.setAttribute("data-theme", theme);
    dispatch(setTheme(theme));
    setSelectedTheme(theme);
  };

  const handleContinue = (recipient) => {
    setSelected(recipient);
    dispatch(setFormData({ relationship: recipient }));
  };

  const handleLanguageChange = (language) => {
    dispatch(setLanguage(language));
    i18n.changeLanguage(language);
    setSelected(t('recipient_crush'));
  };

  useEffect(() => {
    setSelected(t('recipient_crush'));
  }, [i18n.language]);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStep(1), 150),
      setTimeout(() => setStep(2), 450),
      setTimeout(() => setStep(3), 750),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <ValentineBg>
      <div className="nh-page">
        {/* ── Floating Hearts Background ── */}
        <div className="nh-hearts" aria-hidden="true">
          {[...Array(12)].map((_, i) => (
            <span key={i} className={`nh-floating-heart nh-fh-${i + 1}`}>&#9829;</span>
          ))}
        </div>

        {/* ── Top Bar ── */}
        <header className={`nh-topbar ${step >= 1 ? 'show' : ''}`}>
          <div className="nh-topbar-left">
            <span className="nh-brand">{t('title')}</span>
          </div>
          <div className="nh-topbar-right">
            <a href="https://www.keyprediction.com/about-us" className="nh-link d-none d-md-flex">{t('about_us')}</a>
            <div className="nh-lang-switch">
              <button className={`nh-lang ${i18n.language === 'es' ? 'on' : ''}`} onClick={() => handleLanguageChange('es')}>ES</button>
              <button className={`nh-lang ${i18n.language === 'en' ? 'on' : ''}`} onClick={() => handleLanguageChange('en')}>EN</button>
            </div>
          </div>
        </header>

        {/* ── Hero ── */}
        <section className={`nh-hero ${step >= 1 ? 'show' : ''}`}>
          <div className="nh-hero-emoji">💌</div>
          <h1 className="nh-title">{t('get_valentine_card')}</h1>
          <p className="nh-subtitle">{t('assistant_intro')}</p>
        </section>

        {/* ── Theme Cards ── */}
        <section className={`nh-themes ${step >= 2 ? 'show' : ''}`}>
          {themes.map((th) => (
            <button
              key={th.id}
              className={`nh-theme-card ${selectedTheme === th.id ? 'selected' : ''}`}
              onClick={() => handleThemeChange(th.id)}
            >
              <div className="nh-tc-icon">
                <i className={th.icon}></i>
              </div>
              <span className="nh-tc-name">{th.label}</span>
            </button>
          ))}
        </section>

        {/* ── Marquee ── */}
        <div className={`nh-ticker ${step >= 2 ? 'show' : ''}`}>
          {i18n.language === 'es' ? (
            <div className="nh-ticker-track">
              <span>{t('phrase1')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase2')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase3')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase4')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase1')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase2')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase3')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase4')}</span>
            </div>
          ) : (
            <div className="nh-ticker-track">
              <span>{t('phrase1')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase2')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase3')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase4')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase1')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase2')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase3')}</span>
              <span className="nh-ticker-dot">&#9829;</span>
              <span>{t('phrase4')}</span>
            </div>
          )}
        </div>

        {/* ── Recipient Selection Card ── */}
        <section className={`nh-main-card ${step >= 3 ? 'show' : ''}`}>
          <div className="nh-mc-inner">
            <div className="nh-mc-header">
              <span className="nh-mc-badge"><i className="fa-solid fa-robot"></i> IBM watsonx</span>
            </div>
            <h2 className="nh-mc-question">{t('who_is_this_for')}</h2>
            <div className="nh-mc-grid">
              {recipients.map((r, idx) => (
                <Link
                  to="/Chat"
                  key={r.label}
                  className="nh-mc-link"
                  onClick={() => handleContinue(r.label)}
                >
                  <div
                    className={`nh-mc-pill ${selected === r.label ? "active" : ""}`}
                    style={{ animationDelay: `${idx * 0.04}s` }}
                  >
                    <span className="nh-mc-emoji">{r.emoji}</span>
                    <span className="nh-mc-text">{r.label}</span>
                    <i className="fa-solid fa-arrow-right nh-mc-arrow"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ── Footer ── */}
        <footer className="nh-foot">
          <div className="nh-foot-row">
            <span>{t('created_by')} <a href="https://keyprediction.com/" className="nh-foot-a">Key Prediction</a> {t('and')} <a href="https://www.ibm.com/" className="nh-foot-a">IBM</a></span>
            <span className="nh-foot-sep d-none d-md-inline">|</span>
            <span className="nh-foot-copy">&copy; 2026 KeyPrediction</span>
          </div>
          <div className="nh-foot-logos">
            <img src={KP} alt="KP" className="nh-foot-kp" />
            <img src={IBM} alt="IBM" className="nh-foot-ibm" />
          </div>
        </footer>
      </div>
    </ValentineBg>
  );
}

export default NewHome;
